import React, { useState } from 'react';
import { List, Breadcrumb, Row, Col, Button, message, Modal, Input, Progress, Spin, Select, Upload } from 'antd';
import { Link, useNavigate, } from 'react-router-dom';
import axios from 'axios';
import DateilsItemPage from './dateilsItem';
import Client from '../../../../lib/gqlClient';
import { GetAppProjectList, CreateAppProject, GetMembersList, UploadApp } from '../gqls'
import InstructionPage from './instruction'
// import JSZip from 'jszip';
// import plist from 'plist';

window.Buffer = window.Buffer || require("buffer").Buffer;
const AppListPage = (props) => {
    const navigate = useNavigate();
    const { TextArea } = Input;

    const [openInstructionPage, setOpenInstructionPage] = useState(false)

    const [isGetData, setIsGetData] = useState(false)
    const [appPlatform, setAppPlatform] = useState()//ios android
    const [projectList, setProjectList] = useState([]);
    const [openNewApp, setOpenNewApp] = useState(false);

    const [appName, setAppName] = useState();
    const [description, setDescription] = useState();
    const [newAppIcon, setAppIcon] = useState();
    const [newAppName, setNewAppName] = useState();

    const [newAppPackageName, setNewAppPackageName] = useState();
    const [newAppVersionName, setNewAppVersionName] = useState();
    const [newAppVersionCode, setNewAppVersionCode] = useState();
    const [newAppMinSdkVersion, setNewAppMinSdkVersion] = useState();
    const [newAppTargetSdkVersion, setNewAppTargetSdkVersion] = useState();

    const [newAppBuildId, setNewAppBuildId] = useState();
    const [newAppVersion, setNewAppVersion] = useState();
    const [newAppBundleVersion, setNewAppBundleVersion] = useState();
    const [newAppMinimumOsVersion, setNewAppMinimumOsVersion] = useState();
    const [newAppTeamName, setNewAppTeamName] = useState();
    const [newAppTimeTolLive, setNewAppTimeTolLive] = useState();


    const [appFile, setFile] = useState();
    const [uploadPercent, setUploadPercent] = useState();
    const [newAppPlatform, setnewAppPlatform] = useState('')
    const [membersList, setMembersList] = useState([]);
    const [members, setMembers] = useState();
    const [isShowCreateProcess, setShowCreateProcess] = useState(false);
    const [isUpLoadApp, setIsUpLoadApp] = useState(false);
    const [createProcess, setCreateProcess] = useState('');

    React.useEffect(() => {
        getAppProjectList(appPlatform)
        getMembersList();
    }, [])
    function onStart() {
        props.setNewKey('developerCenter/apk/appList')
        navigate('/developerCenter/apk/appList')
    }
    function getAppProjectList(platform) {
        setIsGetData(true)
        Client(
            GetAppProjectList,
            {
                platform: platform,

            },
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setProjectList(res.data.getAppProjectList)
                setIsGetData(false)
            }

        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })

    }
    function getMembersList() {
        Client(
            GetMembersList,
        ).then((res) => {
            console.log(res)
            if (res !== null) {

                var list = [{}]
                res.data.getMembersList.map((item, index) => {
                    list[index] = { value: item, label: item }
                })
                setMembersList(list)
            }

        }).catch(e => {
            // console.log(e);
        })
    }
    function onSelectType(type) {
        if (appPlatform === type) {
            setAppPlatform()
            getAppProjectList()
        } else {
            setAppPlatform(type)
            getAppProjectList(type)
        }

    }
    function onNameChange(value) {
        const data = filterSpecialChar(value.target.value)
        console.log(value.target.value, data)
        setAppName(data)
    }
    const filterSpecialChar = value => {
        var reg = new RegExp('[\\\\",，:：。.?？<>|、/*“”＼／：＂＇]');
        var rs = "";
        for (var i = 0; i < value.length; i++) {
            rs = rs + value.substr(i, 1).replace(reg, "");
        }
        return rs;
    };

    const onItemsMembersClick = (value) => {
        console.log(value)
        if (!members.includes(value)) {
            var list = []
            list = list.concat(members)
            list[members.length] = value
            setMembers(list)
        }
        console.log(list)
    };
    function onDeselectMembers(value) {
        console.log(value)
        var list = [{}]
        members.map((item, index) => {
            list[index] = item
        })
        list.splice(list.indexOf(value), 1)
        setMembers(list)
        console.log(list)
    }
    function onClearMembers() {
        setMembers([])
    }
    const showInpValue = e => {
        setDescription(e.target.value);
    }
    function onRefresh() {
        getAppProjectList(appPlatform)
    }
    function onOpenNewApp() {
        setOpenNewApp(true)
        setMembers([])
        setNewAppName('')
        setnewAppPlatform('')
        setAppName('')
        setDescription('')
        setAppIcon('')
        setMembers([])
        setShowCreateProcess(false)
        setIsUpLoadApp(false)
        setUploadPercent()
    }
    const onCreateApp = (data) => {
        if (appName === '') {
            message.error('Please enter an application name')
            return
        }
        if (newAppIcon === '') {
            message.error('Please add an application')
            return
        }
        setCreateProcess('Creating an application')
        setShowCreateProcess(true)
        Client(
            null,
            {
                name: appName,
                platform: newAppPlatform,
                description: description,
                members: members,
                icon: newAppIcon,
                buildleId: newAppBuildId,
                version: newAppVersion,
                bundleVersion: newAppBundleVersion,
                minimumOsVersion: newAppMinimumOsVersion,
                teamName: newAppTeamName,
                timeTolLive: newAppTimeTolLive,
                packageName: newAppPackageName,
                versionName: newAppVersionName,
                versionCode: newAppVersionCode,
                minSdkVersion: newAppMinSdkVersion,
                targetSdkVersion: newAppTargetSdkVersion
            },
            CreateAppProject
        ).then((res) => {
            console.log(11, res)
            if (res !== null) {
                if (res.data.createAppProject != null) {
                    uploadApp(res.data.createAppProject._id)
                }
            } else {
                message.error('Creation failed')
                setOpenNewApp(false)
                getAppProjectList()

            }

        }).catch(e => {
            // console.log(e);
            setOpenNewApp(false)
            getAppProjectList()
        })

    }
    const up = {
        name: 'file',
        maxCount: 1,
        showUploadList: false,
        beforeUpload: async file => {
            const name = file.name
            if (name.substring(name.length - 3, name.length) === "apk") {
                console.log('android')
                //解析android
                const ApkParser = require('app-info-parser/src/apk')
                const parser = new ApkParser(file)
                parser.parse().then(result => {
                    console.log('app info ----> ', result)
                    console.log('icon base64 ----> ', result.icon)

                    setnewAppPlatform('ANDROID')
                    setNewAppName('app(' + result.versionName + ")")
                    setAppIcon(result.icon)
                    setNewAppPackageName(result.package)
                    setNewAppVersionName(result.versionName)
                    setNewAppVersionCode(result.versionCode.toString())
                    setNewAppMinSdkVersion(result.usesSdk.minSdkVersion.toString())
                    setNewAppTargetSdkVersion(result.usesSdk.targetSdkVersion.toString())
                }).catch(err => {
                    console.log('err ----> ', err)
                })
            } else if (name.substring(name.length - 3, name.length) === "ipa") {
                console.log('ipa')
                //解析ios
                try {
                    // const zip = new JSZip();
                    // const zipContent = await zip.loadAsync(file);
            
                    // let infoPlistPath = '';
                    // zipContent.forEach((relativePath) => {
                    //   if (relativePath.endsWith('Info.plist')) {
                    //     infoPlistPath = relativePath;
                    //   }
                    // });
            
                    // if (infoPlistPath) {
                    //     const infoPlistContent = await zipContent.file(infoPlistPath).async('text');
                    //     const infoPlistData = plist.parse(infoPlistContent);
              
                    //     // Extract required information
                    //     const appName = infoPlistData.CFBundleName || 'N/A';
                    //     const appIconFileName = infoPlistData.CFBundleIcons?.CFBundlePrimaryIcon?.CFBundleIconFiles?.[0] || 'AppIcon';
                    //     const appIcon = await getAppIcon(zip, appName, appIconFileName);
                    //     const appBuildId = infoPlistData.CFBundleVersion || 'N/A';
                    //     const appVersion = infoPlistData.CFBundleShortVersionString || 'N/A';
                    //     const appBundleVersion = infoPlistData.CFBundleVersion || 'N/A';
                    //     const appMinimumOsVersion = infoPlistData.MinimumOSVersion || 'N/A';
                    //     const appTeamName = infoPlistData.CFBundleIdentifier || 'N/A';
                    //     const appTimeTolLive = infoPlistData.CFBundleInfoDictionaryVersion || 'N/A'; // Example key
                    //     setnewAppPlatform('IOS')
                    //     setNewAppName('app(' + appName + ")")
                    //     setAppIcon()
                    //     setNewAppBuildId(appBuildId)
                    //     setNewAppVersion(appVersion)
                    //     setNewAppBundleVersion(appBundleVersion)
                    //     setNewAppMinimumOsVersion(appMinimumOsVersion)
                    //     setNewAppTeamName(appTeamName)
                    //     setNewAppTimeTolLive(appTimeTolLive)
                  
                    //     console.log({
                    //       appName,
                    //       appIcon,
                    //       appBuildId,
                    //       appVersion,
                    //       appBundleVersion,
                    //       appMinimumOsVersion,
                    //       appTeamName,
                    //       appTimeTolLive,
                    //     });
                    // } else {
                    //     console.log('Info.plist file not found in the IPA.');
                    // }
        
                    const IpaParser = require('app-info-parser/src/ipa')
                    const parser = new IpaParser(file)
                    parser.parse().then(result => {
                        console.log('app info ----> ', result)
                        console.log('icon base64 ----> ', result.icon)

                        setnewAppPlatform('IOS')
                        setNewAppName('app(' + result.CFBundleShortVersionString + ")")
                        setAppIcon(result.icon)
                        setNewAppBuildId(result.CFBundleIdentifier)
                        setNewAppVersion(result.CFBundleShortVersionString)
                        setNewAppBundleVersion(result.CFBundleVersion)
                        setNewAppMinimumOsVersion(result.MinimumOSVersion)
                        setNewAppTeamName(result.mobileProvision.TeamName)
                        setNewAppTimeTolLive(result.mobileProvision.TimeToLive.toString())
                    }).catch(err => {
                        console.log('err ----> ', err)
                    })
                } catch (error) {
                    console.log('error ----> ', error)
                }

            }
            setFile(file);
            return false;
        }
    };
    const getAppIcon = async (zip, appName, iconFileName) => {
        if (iconFileName === 'N/A') return null;
        
        // Construct possible paths to the icon file
        const iconPaths = [
          `Payload/${appName}.app/${iconFileName}.png`,
          `Payload/${appName}.app/${iconFileName}.jpg`,
          `Payload/${appName}.app/${iconFileName}`,
        ];
        
        for (const path of iconPaths) {
          const iconFile = zip.file(path);
          if (iconFile) {
            const iconData = await iconFile.async('base64');
            return `data:image/png;base64,${iconData}`;
          }
        }
        
        return null;
      };
    function uploadApp(projectId) {
        setCreateProcess('Create application version')
        Client(
            null,
            {
                projectId: projectId,
                platform: newAppPlatform,
                fileName: newAppName,
                size: appFile.size,
                description: description,
                icon: newAppIcon,
                buildleId: newAppBuildId,
                version: newAppVersion,
                bundleVersion: newAppBundleVersion,
                minimumOsVersion: newAppMinimumOsVersion,
                teamName: newAppTeamName,
                timeTolLive: newAppTimeTolLive,
                packageName: newAppPackageName,
                versionName: newAppVersionName,
                versionCode: newAppVersionCode,
                minSdkVersion: newAppMinSdkVersion,
                targetSdkVersion: newAppTargetSdkVersion
            },
            UploadApp
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                upApp(res.data.uploadApp.url)
            }

        }).catch(e => {
            // console.log(e);
            setOpenNewApp(false)
            getAppProjectList()
        })

    }
    function upApp(url) {
        setCreateProcess('Upload application version')
        setIsUpLoadApp(true)
        axios.put(url
            , appFile, {
            headers: {
                'Content-Type': 'text/plain',
            },
            onUploadProgress: progressEvent => {
                let complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
                console.log(complete)
                setUploadPercent(complete)
            }
        }).then((res) => {
            console.log('upload successfully.', res)
            message.success('upload successfully.')
            setOpenNewApp(false)
            getAppProjectList()
        }).catch((error) => {
            console.log('upload failed.', error)
            message.error('upload failed.')
            setOpenNewApp(false)
            getAppProjectList()
        });
    }
    function showModal() {
        setOpenInstructionPage(false)
    }
    return (
        <div style={{ height: '100%', width: '100%', }}>
            <div style={{ height: '200px', backgroundColor: 'white', borderRadius: '2px' }}>
                {/* 标题头 */}
                <Row>
                    <Col span={16}>
                        <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                            <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>App Distribution</a></Breadcrumb.Item>
                            <Breadcrumb.Item><a style={{ fontSize: '12px' }}>App List</a></Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                        <Button onClick={() => setOpenInstructionPage(true)} type="text" className="btn" style={{ fontSize: '12px', color: '#FF5300', border: 'none' }}>操作指南</Button>
                    </Col>
                    <InstructionPage
                        open={openInstructionPage}
                        showModal={showModal}
                    />
                </Row>

                <div style={{ fontSize: '20px', marginTop: '30px', marginLeft: '150px' }}>App List</div>
                <Row style={{ marginTop: '50px' }}>
                    <Col span={24} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                        <Button className="btn" onClick={() => onSelectType('IOS')} type="text" style={{ color: (appPlatform === 'IOS' ? '#FF5300' : '#000'), border: 'none' }}>iOS</Button>
                        <Button className="btn" onClick={() => onSelectType('ANDROID')} type="text" style={{ color: (appPlatform === 'ANDROID' ? '#FF5300' : '#000'), border: 'none', }}>Android</Button>
                        <Button onClick={() => onOpenNewApp()} style={{ borderRadius: '8px', height: '46px', width: '100px', background: '#FF5300', color: 'white', marginRight: '18px' }} >创建新应用</Button>
                    </Col>
                </Row>
                <Modal
                    centered
                    closable={false}
                    open={openNewApp}
                    footer={null}
                    onCancel={(e) => { setOpenNewApp(false) }}
                    width={500}
                    destroyOnClose={true}
                    maskClosable={false}
                    maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                    bodyStyle={{ padding: '0px', width: '500px', height: '650px', background: 'ffffff', borderRadius: '10px' }}
                    style={{ borderRadius: "10px", overflow: "auto" }}
                >
                    <div style={{ height: '90px', fontSize: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                        创建新应用
                    </div>
                    <div style={{ height: '1px', width: '500px', background: 'rgba(0, 0, 0, 0.1)' }}></div>

                    <Row style={{ height: '46px', marginTop: '25px' }}>
                        <Col style={{ marginLeft: '30px', width: '180px', display: 'flex', alignItems: 'center', fontSize: '18px', color: '#3D3D3D', }}>
                            app名称:
                        </Col>
                        <Col>
                            <Input
                                placeholder="请输入app名称"
                                size="large"
                                value={appName}
                                style={{
                                    width: '250px',
                                    borderRadius: '2px',
                                    height: '40px',
                                    fontSize: '18px',
                                    color: '#3D3D3D',
                                }}
                                onChange={onNameChange}
                            />
                        </Col>
                    </Row>
                    <Row style={{ minHeight: '40px', marginTop: '25px' }}>
                        <Col style={{ marginLeft: '30px', width: '180px', display: 'flex', alignItems: 'center', fontSize: '18px', color: '#3D3D3D', }}>
                            可编辑人员:
                        </Col>
                        <Col >
                            <div style={{
                                width: '250px', minHeight: '40px', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)'
                            }}>
                                <Select
                                    className='select'
                                    mode="multiple"
                                    size='large'
                                    allowClear
                                    style={{
                                        width: '250px',
                                    }}
                                    maxTagCount='responsive'
                                    showArrow={true}
                                    bordered={false}
                                    placeholder="Please select"
                                    onSelect={onItemsMembersClick}
                                    options={membersList}
                                    defaultValue={members}
                                    onClear={onClearMembers}
                                    onDeselect={onDeselectMembers}

                                />
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ height: '150px', marginTop: '25px' }}>
                        <Col style={{ marginLeft: '30px', width: '180px', fontSize: '18px', color: '#3D3D3D', }}>
                            应用描述:
                        </Col>
                        <Col style={{ width: '250px', height: '150px', textAlign: 'right', fontSize: '18px', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)' }}>
                            <TextArea
                                value={description}
                                onChange={showInpValue}
                                style={{ width: '250px', height: '150px', resize: 'none', }} bordered={false} />
                        </Col>
                    </Row>
                    <Row style={{ height: '100px', marginTop: '25px' }}>
                        <Col style={{ marginLeft: '30px', width: '180px', fontSize: '18px', color: '#3D3D3D', }}>
                            添加应用:
                        </Col>
                        <Col>
                            <Upload {...up} style={{ minWidth: '100px' }}>
                                <Button style={{ height: '100px', width: '100px', borderRadius: "4px", }}>
                                    uploadApp
                                </Button>
                            </Upload>
                        </Col>
                        <Col style={{ width: '100px', marginLeft: '10px' }}>
                            <img style={{ visibility: newAppIcon === '' ? 'hidden' : 'visible', width: '100px', height: '100px', borderRadius: "4px", }}
                                src={newAppIcon} />
                        </Col>
                    </Row>
                    <div style={{ marginTop: '5px', textAlign: 'center', color: '#FF5300', fontSize: '16px' }}>若集成新版本提醒功能，请查看右上角操作指南</div>
                    <Row style={{ height: '46px', marginTop: '15px', display: (isShowCreateProcess || isUpLoadApp) ? 'none' : '' }}>
                        <Col span={12}>
                            <Button onClick={() => setOpenNewApp(false)} style={{ marginLeft: '100px', borderRadius: "6px", fontSize: '18px', width: '80px', height: '46px' }}>取消</Button>
                        </Col>
                        <Col span={12}>
                            <Button onClick={() => onCreateApp()} style={{ marginLeft: '70px', borderRadius: "6px", fontSize: '18px', background: '#FF5300', color: 'white', width: '80px', height: '46px', }}>创建</Button>
                        </Col>
                    </Row>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ display: isShowCreateProcess ? '' : 'none', marginTop: '45px', height: '15px' }}>
                            {createProcess}
                        </div>
                    </div>
                    <Progress style={{ visibility: isUpLoadApp ? 'visible' : 'hidden', width: '464px', marginTop: '10px', display: newAppIcon === '' ? 'none' : '', marginLeft: '18px', marginRight: '18px' }}
                        status="active" percent={uploadPercent} type="line" strokeColor='#FF5300' strokeWidth='15px' showInfo={false} />

                </Modal>
            </div>
            <Spin size="large" tip="Loading..." spinning={isGetData} >
                <List
                    grid={{
                        gutter: 20,
                        column: 3,
                    }}
                    dataSource={projectList}
                    renderItem={(item, index) => (
                        <List.Item >
                            <DateilsItemPage
                                item={item}
                                index={index}
                                onRefresh={onRefresh} />
                        </List.Item>

                    )}
                    style={{ marginTop: '20px', width: '1184px' }}
                />
            </Spin>
        </div>
    );
}

export default AppListPage